import { getUrlWithQueryParams } from '@utils/queryParamUtils'
import { cleanRegNo } from '@utils/giCar/registrationValidation'
import logger from '@utils/logger'
import { URLS } from './config'

type CarProposalGiCarContext = {
  setProposalData: (data: any) => void
  registrationNumber?: string
  illogicalFlowData?: unknown
}

export function handleCarProposalSuccess(
  proposalData: any,
  giCarContext: CarProposalGiCarContext,
  fallbackRegistrationNumber: string
) {
  giCarContext.setProposalData(proposalData)
  if (proposalData?.redirect_url) {
    window.location.href = getUrlWithQueryParams(proposalData.redirect_url)
    return
  }
  if (proposalData?.ekey) {
    const registrationNumber = cleanRegNo(
      proposalData?.registration_number ||
        giCarContext.registrationNumber ||
        fallbackRegistrationNumber ||
        ''
    )
    const redirectUrl = URLS.FRESH_CAR_TEMPLATE(proposalData.ekey, registrationNumber)
    window.location.href = getUrlWithQueryParams(redirectUrl)
    return
  }
  logger.warn('Car proposal success without redirect_url or ekey', {
    registration_number: fallbackRegistrationNumber,
  })
}

export function handleCarProposalSubmissionError(
  error: unknown,
  giCarContext: CarProposalGiCarContext,
  setShowIllogicalModal: (open: boolean) => void,
  onNonIllogicalError?: () => void
) {
  logger.error('Submission error:', error)
  const typedError = error as { type?: string }
  if (typedError?.type === 'illogical_flow' || giCarContext.illogicalFlowData) {
    setShowIllogicalModal(true)
    return
  }
  onNonIllogicalError?.()
}
